import { ElMessage, ElMessageBox } from 'element-plus'

/** 与颜色管理「新增/编辑」表单一致的可提交字段（创建时） */
export function buildColorCreatePayload(formData, forceCreate = false) {
  const submitData = {
    internal_name_en: formData.internal_name_en,
    internal_name_cn: formData.internal_name_cn,
    is_active: formData.is_active,
    force_create: !!forceCreate
  }
  if (formData.is_manual_color_code) {
    submitData.manual_color_code = formData.manual_color_code
    submitData.is_manual_color_code = formData.is_manual_color_code
  }
  if (formData.is_manual_short_code) {
    submitData.color_short_code = formData.color_short_code
    submitData.is_manual_short_code = formData.is_manual_short_code
  }
  return submitData
}

/**
 * 从 axios / API 错误中解析颜色创建接口返回体（400 等）
 */
export function parseColorCreateError(error) {
  if (error?.response?.data) {
    return error.response.data
  }
  if (error?.data) {
    return error.data
  }
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return error
  }
  return { message: error?.message || '操作失败，请稍后重试' }
}

/**
 * 与颜色管理页一致：完全相同名称，不允许创建
 */
export async function showBlockedColorCreateAlert(exactMatches) {
  const matches = exactMatches || []
  let errorMessage =
    '<div style="text-align: left;"><p style="color: #F56C6C;"><strong>错误：检测到完全相同的颜色名称，不允许创建！</strong></p>'
  errorMessage += '<p style="margin: 10px 0;">以下颜色与您要创建的颜色完全相同：</p>'
  errorMessage +=
    '<table style="width: 100%; border-collapse: collapse; margin: 10px 0; font-size: 13px;">'
  errorMessage +=
    '<tr style="background-color: #f5f7fa;"><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">ID</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">英文名称</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">中文名称</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">匹配字段</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">匹配值</th></tr>'

  matches.forEach((match) => {
    errorMessage += `<tr>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.color_id}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.internal_name_en || '-'}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.internal_name_cn || '-'}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.similarity_type || '-'}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6; color: #E6A23C;">${match.matched_value || '-'}</td>
    </tr>`
  })
  errorMessage += '</table>'
  errorMessage += '<p style="color: #909399; margin-top: 10px;">请修改颜色名称后再试。</p></div>'

  await ElMessageBox.alert(errorMessage, '颜色名称重复错误', {
    type: 'error',
    confirmButtonText: '确定',
    dangerouslyUseHTMLString: true
  })
}

/**
 * 与颜色管理页一致：相似颜色二次确认。resolve(true) 表示用户确认强制创建
 */
export async function confirmSimilarColorsCreate(similarColors) {
  const similar = similarColors || []
  let warningMessage =
    '<div style="text-align: left;"><p style="color: #E6A23C;"><strong>警告：检测到相似的颜色名称！</strong></p>'
  warningMessage +=
    '<p style="margin: 10px 0;">以下颜色与您要创建的颜色相似（相似度≥60%或包含关系）：</p>'
  warningMessage +=
    '<table style="width: 100%; border-collapse: collapse; margin: 10px 0; font-size: 13px;">'
  warningMessage +=
    '<tr style="background-color: #f5f7fa;"><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">ID</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">英文名称</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">中文名称</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">匹配字段</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">匹配值</th><th style="padding: 8px; border: 1px solid #dcdfe6; text-align: left;">匹配原因</th></tr>'

  similar.forEach((match) => {
    const similarity = match.match_reason || `${((match.similarity ?? 0) * 100).toFixed(0)}%`
    warningMessage += `<tr>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.color_id}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.internal_name_en || '-'}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.internal_name_cn || '-'}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6;">${match.similarity_type || '-'}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6; color: #E6A23C;">${match.matched_value || '-'}</td>
      <td style="padding: 8px; border: 1px solid #dcdfe6; color: #909399;">${similarity}</td>
    </tr>`
  })
  warningMessage += '</table>'
  warningMessage +=
    '<p style="color: #E6A23C; margin-top: 10px;"><strong>请仔细比较后，确定是否要继续创建？</strong></p></div>'

  await ElMessageBox.confirm(warningMessage, '颜色名称相似警告', {
    type: 'warning',
    confirmButtonText: '确定创建',
    cancelButtonText: '取消',
    confirmButtonClass: 'el-button--danger',
    dangerouslyUseHTMLString: true,
    width: '600px'
  })
  return true
}

/**
 * 处理创建颜色 API 错误：blocked / 相似确认 / 其它
 * @returns {'blocked'|'retry_force'|'cancelled'|'other'} 或抛出非 cancel 异常
 */
export async function handleColorCreateError(error, { onConfirmForceCreate }) {
  const errorData = parseColorCreateError(error)

  if (errorData?.blocked) {
    await showBlockedColorCreateAlert(errorData.exact_matches)
    return 'blocked'
  }

  if (errorData?.requires_confirmation) {
    try {
      await confirmSimilarColorsCreate(errorData.similar_colors)
      if (typeof onConfirmForceCreate === 'function') {
        await onConfirmForceCreate()
      }
      return 'retry_force'
    } catch (confirmError) {
      if (confirmError === 'cancel') {
        return 'cancelled'
      }
      throw confirmError
    }
  }

  const errorMsg = errorData?.message || error?.message || '操作失败，请稍后重试'
  ElMessage.error(errorMsg)
  return 'other'
}
